module.exports = "//cdn.mxpnl.com/static/asset-cache/a7cd67cd9de2b59e78fee626fedd0ad4/iron/common/components/warning/images/laptop.svg";